import { i18n, SupportedLocale } from '@/services/i18n';
import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/de';

import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/es';
import 'vue2-datepicker/locale/de';

// @ts-ignore
import antRu from 'ant-design-vue/es/date-picker/locale/ru_RU';
// @ts-ignore
import antEn from 'ant-design-vue/es/date-picker/locale/en_US';
// @ts-ignore
import antEs from 'ant-design-vue/es/date-picker/locale/es_ES';
// @ts-ignore
import antDe from 'ant-design-vue/es/date-picker/locale/de_DE';

const antDatePickerLocaleMap: Record<SupportedLocale, any> = {
  ru: antRu,
  en: antEn,
  es: antEs,
  de: antDe,
};

const momentLocaleMap: Record<SupportedLocale, string> = {
  ru: 'ru',
  en: 'en',
  es: 'es',
  de: 'de',
};

const vue2DatepickerLangMap: Record<SupportedLocale, string> = {
  ru: 'ru',
  en: 'en',
  es: 'es',
  de: 'de',
};

export function getAntDatePickerLocale(): any {
  const locale = i18n.locale as SupportedLocale;
  return antDatePickerLocaleMap[locale] || antDatePickerLocaleMap.ru;
}

export function getVue2DatepickerLang(): string {
  const locale = i18n.locale as SupportedLocale;
  return vue2DatepickerLangMap[locale] || vue2DatepickerLangMap.ru;
}

export function syncMomentLocale(): void {
  const locale = i18n.locale as SupportedLocale;
  moment.locale(momentLocaleMap[locale] || 'ru');
}

syncMomentLocale();
